import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface TrainingFilterStateType {
    search: string;
    page: number;
    orderBy: string;
    orderDir: string;
    catSlug: string | null;
}

const initialState: TrainingFilterStateType = {
    search: "",
    page: 1,
    orderBy: "",
    orderDir: "",
    catSlug: null
};

export const trainingFilterSlice = createSlice({
    name: 'trainingFilter',
    initialState,
    reducers: {
        setSearch: (state, action: PayloadAction<string>) => {
            state.page = 1
            state.search = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.orderBy = action.payload;
        },
        setOrderDir: (state, action: PayloadAction<string>) => {
            state.orderDir = action.payload;
        },
        setCategory: (state, action: PayloadAction<string | null>) => {
            state.catSlug = action.payload;
        },
        setAllFilters: (state, action: PayloadAction<TrainingFilterStateType>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const {
    setSearch,
    setPage,
    setOrderBy,
    setOrderDir,
    setCategory,
    setAllFilters,
} = trainingFilterSlice.actions;

export default trainingFilterSlice.reducer;

// Correct selector based on slice name `trainingFilter`
export const trainingFilterSelector = (state: RootState) => state.trainingFilter;

export const searchSelector = createSelector(
    [trainingFilterSelector],
    (filters) => filters.search
);

export const pageSelector = createSelector(
    [trainingFilterSelector],
    (filters) => filters.page
);

export const orderBySelector = createSelector(
    [trainingFilterSelector],
    (filters) => filters.orderBy
);

export const orderDirSelector = createSelector(
    [trainingFilterSelector],
    (filters) => filters.orderDir
);

export const trainingSelector = createSelector(
    [trainingFilterSelector],
    (filters) => filters
);

export const catSelector = createSelector(
    [trainingFilterSelector],
    (filters) => filters.catSlug
);
